import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * On every route change, snap the page back to the top.
 * Skips smooth-scroll on route change so users don't watch the whole page fly by;
 * uses `instant` so the new page opens where a document normally would.
 * Ignores `#anchor` navigations (those already scroll the anchor into view).
 */
export default function ScrollToTop() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) return; // let anchor links (e.g. /#consultation) behave normally
    try {
      window.scrollTo({ top: 0, left: 0, behavior: "instant" });
    } catch {
      window.scrollTo(0, 0);
    }
  }, [pathname, hash]);

  return null;
}
